import React, { useEffect } from "react";
import { StepConfig } from "../../contexts";

type Props = {
  currentStep: [number, number];
  steps: StepConfig;
};

const DashboardProgressBar = ({ steps, currentStep }: Props) => {
  return (
    <div className="cx-w-full cx-bg-white-80">
      <div className="cx-flex cx-flex-row cx-justify-center cx-w-full cx-px-2 cx-py-4">
        {steps.map((step, idx) => {
          let status = MilestoneStatusType.CURRENT;
          if (currentStep[0] > idx) status = MilestoneStatusType.COMPLETED;
          if (currentStep[0] < idx) status = MilestoneStatusType.INCOMPLETE;
          return !step.hideProgress ? (
            <Milestone key={step.name} title={step.name} status={status} />
          ) : null;
        })}
      </div>
    </div>
  );
};

enum MilestoneStatusType {
  COMPLETED = "completed",
  CURRENT = "current",
  INCOMPLETE = "incomplete",
}

type MilestoneProps = {
  title: string;
  status: MilestoneStatusType;
};

const Milestone = ({ title, status }: MilestoneProps) => {
  const getDashCount = () => {
    if (typeof window !== "undefined") {
      const width = window.innerWidth;
      if (width < 640) return 6;
      else if (width < 768) return 8;
      else return 11;
    }
    return 8;
  };

  const [dashCount, setDashCount] = React.useState(getDashCount);

  useEffect(() => {
    const handleResize = () => {
      setDashCount(getDashCount());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderProgressLine = () => {
    if (status === "completed") {
      return (
        <div className="cx-grow cx-h-1 cx-bg-brand-primary-regular cx-rounded-checkbox"></div>
      );
    } else if (status === "current") {
      return (
        <div className="cx-grow cx-flex cx-justify-evenly cx-items-center">
          {Array.from({ length: dashCount }, (_, dashIdx) => (
            <div
              key={dashIdx}
              className="cx-w-2 cx-h-1 cx-rounded-checkbox cx-bg-brand-primary-regular"
            ></div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="cx-grow cx-h-1 cx-bg-background-tertiary cx-rounded-checkbox"></div>
      );
    }
  };

  return (
    <div
      className={`cx-flex-col cx-justify-start cx-items-center cx-m-2 cx-w-47 ${
        status !== "current" ? "cx-hidden sm:cx-flex" : "cx-flex"
      }`}
    >
      <div className="cx-flex cx-flex-row cx-w-full cx-items-center">
        {renderProgressLine()}
      </div>
      <div
        className={`cx-text-xs cx-mt-2 cx-text-center cx-uppercase cx-tracking-[1px] ${
          status === "incomplete"
            ? "cx-text-text-tertiary"
            : "cx-text-brand-primary-regular cx-font-semibold"
        }`}
      >
        {title}
      </div>
    </div>
  );
};

export default DashboardProgressBar;
